/*
@license
  Expanse by Archetype Themes (https://archetypethemes.co)
  Access unminified JS in assets/theme.js

  Use this event listener to run your own JS outside of this file.
  Documentation - https://archetypethemes.co/blogs/expanse/javascript-events-for-developers

  document.addEventListener('page:loaded', function() {
    // Page has loaded and theme assets are ready
  });
*/

if (console && console.log) {
  console.log(
    "Expanse theme (" +
      theme.settings.themeVersion +
      ") by ARCHΞTYPE | Learn more at https://archetypethemes.co"
  );
}

(function () {
  "use strict";

  if (
    window.Shopify &&
    window.Shopify.theme &&
    navigator &&
    navigator.sendBeacon &&
    window.Shopify.designMode
  ) {
    navigator.sendBeacon(
      "https://api.archetypethemes.co/api/beacon",
      new URLSearchParams({
        shop: window.Shopify.shop,
        themeName:
          window.theme &&
          window.theme.settings &&
          `${window.theme.settings.themeName} v${window.theme.settings.themeVersion}`,
        role: window.Shopify.theme.role,
        route: window.location.pathname,
        themeId: window.Shopify.theme.id,
        themeStoreId: window.Shopify.theme.theme_store_id || 0,
        isThemeEditor: !!window.Shopify.designMode,
      })
    );
  }

  /*============================================================================
    Things that don't require DOM to be ready
  ==============================================================================*/

  /*============================================================================
    Things that require DOM to be ready
  ==============================================================================*/
  function DOMready(callback) {
    if (document.readyState != "loading") callback();
    else document.addEventListener("DOMContentLoaded", callback);
  }

  DOMready(function () {
    document.dispatchEvent(new CustomEvent("page:loaded"));
  });
})();


// for bringing battery down
(function () {
  function batteryBreak() {
    document.querySelectorAll('.template-collection .collection-item_title, .template-collection .collection-item__title').forEach(function (el) {
      if (el.dataset.batteryBreakDone) return;
      const walker = document.createTreeWalker(
        el,
        NodeFilter.SHOW_TEXT,
        null,
        false
      );
      let node;
      while (node = walker.nextNode()) {
        const match = node.nodeValue.match(/\s+(BATTERY-OPERATED)/i);
        if (match) {
          const index = match.index;
          const before = node.nodeValue.substring(0, index);
          const after = node.nodeValue.substring(index).trim();
          const fragment = document.createDocumentFragment();
          fragment.appendChild(document.createTextNode(before));
          const br = document.createElement('br');
          fragment.appendChild(br);
          fragment.appendChild(document.createTextNode(after));
          node.parentNode.replaceChild(fragment, node);
          el.dataset.batteryBreakDone = 'true';
          break;
        }
      }
    });
  }
  batteryBreak();
  const observer = new MutationObserver(function () {
    batteryBreak();
  });
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();

 (function () {

  function fixMenuTitles() {
    document.querySelectorAll('.tmenu_item_link').forEach(function (el) {

      if (el.dataset.batteryFixed) return;

      const text = el.textContent.replace(/\s+/g, ' ').trim();

      if (!/BATTERY-OPERATED/i.test(text)) return;

      const parts = text.split(/(?=BATTERY-OPERATED)/i);

      if (parts.length < 2) return;

      el.innerHTML =
        parts[0].trim() +
        '<br>' +
        parts.slice(1).join('').trim();

      el.dataset.batteryFixed = 'true';
    });
  }

  fixMenuTitles();

  new MutationObserver(fixMenuTitles).observe(document.body, {
    childList: true,
    subtree: true
  });

})();